export const scrapeApi = "https://cardtable-scrape-decks.middle-earth.house";

// Uncomment below to test against local dev version of scraping microservice
// export const scrapeApi =
//   "https://local-cardtable-scrape-decks.middle-earth.house";
